<template>

</template>
<script>
export default {
  name: "core-emit",
  props: {
                     state: {
                         type: String,
                         default: 0
                     }
                 },
                 methods: {
                     onDispatch: function() {
                         this.eventHub.$emit(this.state)
                     }
                 }
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/core-emit/index.vue